import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useGlobalContext } from "../../hooks/context";
import NotFound from "../../components/404";

const { REACT_APP_LOGIN_AUTHOR_EMAIL: authorEmail } = process.env;

export default function AuthorOutlet() {
  const location = useLocation();
  const { user } = useGlobalContext();

  if (user.isLoggedIn && user.email === authorEmail) {
    return <Outlet />;
  } else if (user.isLoggedIn && user.email !== authorEmail) {
    return <NotFound />;
  } else {
    return <Navigate to="/login" state={{ from: location }} />;
  }
}
